<template>
  <div class="wrapper"  ref="wrapper" :style="`backgroundColor:${ui.bg_color};`">
    <!-- 头图 -->
    <header ref="head">
      <img :src="ui.head" alt="头图" class="header_img"/>
    </header>

    <!-- 展会默认只有手机号一项， 展会非家博会（手机号+姓名二项），城市根据项目设定是否添加 -->
    <!-- 默认模版 -->
    <template v-if="mid == 0">
      <FormDefault
          :ui="ui" :stime="stime" :action_form="action_form"
          :tid="Number(tid)"
          :is_name="is_name"
          :is_city="is_city" :city_show="city_show" :is_stop="is_stop"
          :is_show_car="false"
          @openCityDialog="clk_city"
          @submitForm="submitForm"
      ></FormDefault>
    </template>

    <!-- 模版一 -->
    <template v-else-if="mid == 1">
      <FormOne :ui="ui" :stime="stime" :action_form="action_form"
               :tid="Number(tid)"
               :is_name="is_name"
               :custom_wrap="custom_wrap"
               :custom_form="custom_form"
               :is_city="is_city" :city_show="city_show" :is_stop="is_stop"
               :is_show_car="false"
               @openCityDialog="clk_city"
               @submitForm="submitForm"
      ></FormOne>
    </template>

    <!-- 模版二 -->
    <template v-else-if="mid == 2">
      <FormTwo
          :ui="ui" :stime="stime" :action_form="action_form"
          :tid="Number(tid)"
          :is_name="is_name"
          :custom_wrap="custom_wrap"
          :custom_form="custom_form"
          :is_city="is_city" :city_show="city_show" :is_stop="is_stop"
          :is_show_car="false"
          @openCityDialog="clk_city"
          @submitForm="submitForm"
      ></FormTwo>
    </template>

    <!-- 模版三 -->
    <template v-else-if="mid == 3">
      <FormThree
          :ui="ui" :stime="stime" :action_form="action_form"
          :tid="Number(tid)"
          :is_name="is_name"
          :custom_wrap="custom_wrap"
          :custom_form="custom_form"
          :is_city="is_city" :city_show="city_show" :is_stop="is_stop"
          :is_show_car="false"
          @openCityDialog="clk_city"
          @submitForm="submitForm"
      ></FormThree>
    </template>

    <!-- 模版四 -->
    <template v-else-if="mid == 4">
      <FormFour
          :ui="ui" :stime="stime" :action_form="action_form"
          :tid="Number(tid)"
          :is_name="is_name"
          :is_city="is_city" :city_show="city_show" :is_stop="is_stop"
          :is_opacity="is_opacity"
          :is_show_car="false"
          @openCityDialog="clk_city"
          @submitForm="submitForm"
      ></FormFour>
    </template>

    <!-- 模版五-->
    <template v-else-if="mid == 5">
      <FormFive
          :ui="ui" :stime="stime" :action_form="action_form"
          :tid="Number(tid)"
          :is_name="is_name"
          :custom_wrap="custom_wrap"
          :custom_form="custom_form"
          :is_city="is_city" :city_show="city_show" :is_stop="is_stop"
          :is_opacity="is_opacity"
          :is_show_car="false"
          @openCityDialog="clk_city"
          @submitForm="submitForm"
      ></FormFive>
    </template>

    <!-- 模版六-->
    <template v-else-if="mid == 6">
      <FormSix
          :ui="ui" :stime="stime" :action_form="action_form"
          :tid="Number(tid)"
          :is_city="is_city" :city_show="city_show" :is_stop="is_stop"
          :form_dialog="form_dialog"
          :is_show_car="false"
          @openCityDialog="clk_city"
          :is_name="is_name"
          @submitForm="submitForm"
          @showRealForm="showRealForm"
      ></FormSix>
    </template>


    <div class="detail_img" :class="btn_show ? 'pb_44' : ''">
      <!-- 详情图-->
      <img :src="ui.tail" alt="" class="detail_img" ref="tailImage"/>
    </div>
    <!-- 版权-->
    <div>
      <copyright v-if="ui.is_copyright" :btn_show="btn_show"></copyright>
    </div>
    <div v-if="btn_show" class="footer_wrapper">
      <div class="bottom_btn"
           @click="btn_click_form"
           :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
        {{ui.btn_text}}
      </div>
    </div>

    <!-- 报名成功弹框-->
    <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" width="50%">
      <el-result icon="success" title="报名成功"></el-result>
    </el-dialog>

    <!-- 城市弹框-->
    <!--:style="{height: '50%'}" :lock-scroll="false"-->
    <van-popup v-model="city_show" round position="bottom" :safe-area-inset-bottom="true">
      <!--  style="height: 100%;overflow-x: hidden;overflow-y: auto"-->
      <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="citys"
          :fieldNames="cityNames"
          @close="city_show = false"
          @finish="finishCity"
          class="city_cascader"
      />
    </van-popup>
  </div>
</template>

<script>
  import countDown from "@/components/countDown";
  import policy from "@/components/policy";
  import copyright from "@/components/copyright";
  import banner from "@/components/banner";
  import _geturl from "@/utils/_geturl";
  import lib_activity from "@/libs/lib_activity";
  import lib_city from "@/libs/lib_city";
  import _wx from "@/common/_wx";
  import _time from "@/utils/_time";
  import _object from "@/utils/_object";
  import _regular from "@/utils/_regular";
  import lib_clue from "@/libs/lib_clue";
  import lib_success from "@/libs/lib_success";
  import cache_url from "@/cache/cache_url";
  import Toast from "vant/lib/toast";
  import _monitor from "@/monitor/_monitor";
  import _config from "@/common/_config";

  import remainTicket from "@/components/remainTicket";
  import vantCountDown from "@/components/vantCountDown";
  import registNumber from "@/components/registNumber";
  import FormDefault from "@/components/formTemp/FormDefault";
  import FormOne from "@/components/formTemp/FormOne";
  import FormTwo from "@/components/formTemp/FormTwo.vue";
  import FormThree from "@/components/formTemp/FormThree.vue";
  import FormFour from "@/components/formTemp/FormFour.vue";
  import FormFive from "@/components/formTemp/FormFive.vue";
  import FormSix from "@/components/formTemp/FormSix.vue";

  let action_form = {
    name: "", //姓名
    phone: "", //电话
    city: "", //城市
  };

  export default {
    name: "common",
    components: {
      countDown,
      policy,
      copyright,
      banner,
      remainTicket,
      vantCountDown,
      registNumber,
      FormDefault,
      FormOne,
      FormTwo,
      FormThree,
      FormFour,
      FormFive,
      FormSix,
    },
    data() {
      return {
        title: "", // document的title
        activity_id: 0, //活动ID
        tids: "", //模板ID
        channel: "", //渠道
        channel_name: "", //渠道名
        tid: 0, // 有无车型库
        share_theme: "", //分享描述
        stime: 0, // 项目开始时间
        etime: 0, // 项目结束时间
        ui: {
          head: "", //头图
          tail: "", //详情图
          share: "", //分享图
          bg_color: "", //表单背景色
          font_color: "", //文本颜色
          btn_bg_color: "", //按钮背景色
          btn_font_color: "", //按钮文本颜色
          btn_text: "", //按钮文本值
          btm_btn_text: "", //底部按钮文本
          is_banner: 0, //是否有轮播图
          is_counter: 0, //是否有倒计时
          is_copyright: 1, //协议
          jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
        },

        action_form: action_form,
        //城市联级选择
        citys: [], //城市数据
        cascaderProps: {
          //配置项
          expandTrigger: "hover", //展开方式
          value: "id", //指定选项的值
          label: "name", //指定选项标签
          children: "children", //指定选项的子选项
          emitPath: false, //该节点数组
        },

        is_success: false, //报名成功弹框
        is_city: false, //表单城市项，默认无城市
        is_stop: false, //活动是否已结束
        is_display: true, //底部按钮
        btn_show: false, //底部按钮显隐
        series_name: "请选择意向车型",

        // vant相关
        city_show: false,
        cascaderValue: "", //
        cityNames: {
          text: "name",
          value: "id",
          children: "children",
        },
        mid: 0, //落地页模版
        form_dialog: false,
        t: 0, //时间戳
        is_name: true, //是否显示姓名项

      };
    },
    created() {
      // 地址栏
      this.activity_id = _geturl("activity_id");
      this.tids = _geturl("tids");
      this.channel = _geturl("channel");
      this.channel_name = _geturl("channel_name");
      this.mid = _geturl("mids") || 0;
      this.t = _geturl("t") || 0;

      //获取项目信息
      lib_activity.info(this.activity_id,this.tids,this.mid,this.t,this.init_info);

      //监测
      _monitor.init(this.channel, this.activity_id);
    },
    mounted() {
      // 监听页面滚动
      window.addEventListener("scroll", this.handleScroll, true);
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll, true);
    },
    destroyed() {
      // window.removeEventListener('scroll', this.handleScroll())
    },
    methods: {
      //初始化项目信息
      init_info(data) {
        console.log(data);
        this.title = data.activity.theme;
        document.title = this.title;
        this.share_theme = data.activity.share_theme;
        this.etime = data.activity.etime;
        this.stime = data.activity.stime;
        this.tid = data.activity.tid;
        this.mid = data.mid;
        if (data.ui == null) {
          this.ui = {};
          return;
        }
        this.ui = data.ui;
        // 项目结束
        if (!data.activity.state || _time._current() > data.activity.etime) {
          this.is_stop = true;
          return;
        }
        // 判断是否有城市
        let city = [];
        if (data.activity.city) {
          city = data.activity.city.split(",");
        }
        if (city.length == 1 && city[0] > 0) {
          //单城市项目
          this.is_city = false;
        } else {
          //多城市项目
          this.is_city = true;
          this.getCity(data.activity.city);
        }
        // 分享： ui存在再分享
        if (_object._length(this.ui) > 0) {
          this.share();
        }
        // 是否显示姓名
        //
        this.is_name = false
      },

      // 分享
      share() {
        let that = this;
        lib_activity.share(function (data) {
          let options = {};
          options.title = that.title;
          options.desc = that.share_theme;
          options.link = window.location.href;
          options.image = that.ui.share;
          _wx.js_api(data, _wx.share, options);
        });
      },
      // 加载城市
      getCity(city) {
        let that = this;
        lib_city.list(city, function (data) {
          that.citys = data;
        });
      },

      clk_city() {
        this.city_show = true;
      },

      showRealForm() {
        this.form_dialog = true;
      },

      submitForm() {
        if (this.is_name && !this.action_form.name) {
          Toast("请输入您的姓名");
          return;
        }
        if (
            this.is_name &&
            this.action_form.name &&
            this.action_form.name.length > 20
        ) {
          Toast("请输入正确的姓名");
          return;
        }
        if (!this.action_form.phone) {
          Toast("请输入您的手机号");
          return;
        }
        if (!_regular.is_mobile(this.action_form.phone)) {
          Toast("请输入正确的手机号");
          return;
        }

        if (this.is_city && !this.action_form.city) {
          Toast("请选择城市");
          return;
        }

        let cityArr = this.action_form.city.split("/"); // vant形式
        let location = this.is_city ? cityArr[0] + "+" + cityArr[1] : "";
        let url = window.location.href;
        let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
        let params = {
          activity_id: this.activity_id,
          channel_code: this.channel,
          channel_name: this.channel_name,
          location,
          url,
          form_name: this.action_form.name,
          form_phone: this.action_form.phone,
          form_ui_id,
          form_mid: this.mid,
        };
        let that = this;
        // console.log(params, '入参');
        lib_clue.receive(params, function (data) {
          //监测上报
          _monitor.submit();

          //缓存当页面链接
          cache_url.set(window.location.href);
          //跳转
          // setTimeout(() => {
          // }, 2000);
          //不同参数跳转不同页面
          const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0;
          //跳转地址
          const url = lib_success.jmp_url(jmp_url);
          that.$router.push({
            path: url,
            query: {
              id: data.id,
            },
          });
        });
      },

      // 滚到表单开始部分
      btn_click_form() {
        let form_top = this.$refs.head.offsetHeight - 50;
        document.documentElement.scrollTop = form_top;
        document.body.scrollTop = form_top;
        document.querySelector("#app").scrollTop = form_top;
      },
      // 滚动
      handleScroll() {
        let scrollHeight =
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            document.querySelector("#app").scrollTop;
        this.$nextTick(() => {
          if (scrollHeight >= this.$refs.tailImage.offsetTop) {
            this.btn_show = true;
          } else {
            this.btn_show = false;
          }
        });
      },

      // vant相关
      finishCity({ selectedOptions }) {
        this.city_show = false;
        this.action_form.city = selectedOptions
            .map((option) => option.name)
            .join("/");
      },
    },
    computed: {
      is_opacity: function () {
        // return  this.ui.btn_font_color
        return this.is_stop
            ? this.ui.btn_font_color + "80"
            : this.ui.btn_font_color;
      },
      custom_form: function() {
        let form_num = '1'

        if(this.is_city && this.is_name) {
          form_num = '3'
        } else if(this.is_city || (!this.is_city && this.is_name)) {
          form_num = '2'
        } else if(!this.is_city && !this.is_name){
          form_num = '1'
        }
        return `form-height-${form_num}`
      },
      custom_wrap: function() {
        let form_num = '1'
        if(this.is_city && this.is_name) {
          form_num = '3'
        } else if(this.is_city || (!this.is_city && this.is_name)) {
          form_num = '2'
        } else if(!this.is_city && !this.is_name){
          form_num = '1'
        }
        return `wrap-height-${form_num}`
      },
    },

  };
</script>

<style lang="less" scoped>
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/form.less";
  // form部分
  @import "../../assets/style/common/successful.less"; //报名成功
  @import "../../assets/style/autoshow/base_form.less";
  .city_cascader {
    /deep/ .van-tabs .van-tabs--line .van-cascader__tabs {
      overflow-y: auto;
    }
  }
</style>

<style lang="less">
  @import "../../assets/style/autoshow/new_base_form.less";
</style>

